import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useMutation, useQuery } from "@apollo/client";
import { AFTER_FOURDAY_NOT_PAYMENT_ORDER, GET_FOUR_DAY_ORDER_PAYMENT, GET_PAYMENT_ORDERS, IS_OPEN_TODAY_PICKUP_ORDER } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import AdminHeader from "./AdminHeader.js";
import { UPDATE_TODAY_PAYMENT_STATUS } from "../graphql/Mutation/Ordre.js";
import PendingPickupOrderList from "./PendingPickupOrderList.js";

import Table from "../components/Table/index.jsx";


const OpenPendingPickupOrder = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);
    const [searchUser, setSearchUser] = useState('');
    const [isOpenTodayPickup, setisOpenTodayPickup] = useState('');


    const { data: GetOrderOrder, loading, refetch } = useQuery(IS_OPEN_TODAY_PICKUP_ORDER, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "email": searchUser,
            isOpenTodayPickup: isOpenTodayPickup
            // "codPaymentStatus": cod_payment_status
        },
        fetchPolicy: "cache-and-network"
    })
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);


    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    const [openClosePickup] = useMutation(UPDATE_TODAY_PAYMENT_STATUS);


    useEffect(() => {
        if (GetOrderOrder?.getOpenTodayPickupOrder?.data) {
            setOrderData(GetOrderOrder?.getOpenTodayPickupOrder?.data);
        }
    }, [GetOrderOrder]);
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        tab === "Open Today Pickup" ? setisOpenTodayPickup("true") : tab === "Close Today Pickup" ? setisOpenTodayPickup("false") : setisOpenTodayPickup('')

    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };

    const toggleClose = async (customerId, isOpen) => {
        try {
            await openClosePickup({
                variables: { input: { customerId, isOpenTodayPickup: isOpen } },
            });
            refetch();
        } catch (err) {
            console.error("Error updating payment status:", err);
        }
    };

    const columns = [
        { name: "No.", selector: (row, index) => index + 1 + ((page - 1) * limit), sortable: true },
        {
            name: "Date",
            selector: (row) => moment(row.createdAt).format("DD/MM/YYYY hh:mm A"),
            sortable: true,
        },
        {
            name: "Email ID",
            selector: (row) => row?.email,
            cell: (row) => (
                <span className="text-blue-600 font-semibold cursor-pointer">
                    {row?.email}
                </span>
            ),
            sortable: true,
        },
        {
            name: "Total Shipment Count",
            selector: (row) => row?.totalOrders,
            sortable: true,
        },
        {
            name: "Shipment Details",
            cell: (row) => (
                <Link
                    to="/PendingPickupOrderList"
                    state={{ customerId: row?.customerId, email: row?.email }}
                    className="text-blue-600 font-semibold cursor-pointer hover:underline"
                >
                    View Details
                </Link>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
        },
        {
            name: "Close",
            cell: (row) => (
                <button
                    onClick={() => toggleClose(row?.customerId, !row?.isOpenTodayPickup)}
                    className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                >
                    {row?.isOpenTodayPickup ? "Close" : "Open"}
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
        },
    ];
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            Open Today Pending Pickup Shipment History
                        </h1>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value) }}
                            />
                        </div>
                    </div>
                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Open Today Pickup",
                            "Close Today Pickup",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Shipment Table Section */}
                <h1 className="mt-7 mb-2 font-bold text-gray-800">
                    Today Pending Pickup Shipment List  - <span className="font-medium">Seller Wise</span>
                </h1>

                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={columns}
                        data={orderData || []}
                        currentPage={page}
                        totalRecords={orderData?.length > 0 || 0}
                        limit={limit}
                        setPage={setPage}
                        setLimit={setLimit}
                        loading={loading}
                        handlePagination={(newPage) => setPage(newPage)}
                    />
                </div>

                {/* <div className="bg-slate-50 rounded-t-lg border mb-1 border-slate-300">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                            <thead className="bg-slate-100 text-gray-700">
                                <tr>
                                    <th className="px-4 py-3">No.</th>
                                    <th className="px-4 py-3">Email ID</th>
                                    <th className="px-4 py-3">Total Shipment Count</th>
                                    <th className="px-4 py-3">Shipment Details</th>
                                    <th className="px-4 py-3" >Close</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="16" className="text-center py-20">
                                            <SpinLoader classNamecolor="true" />
                                        </td>
                                    </tr>
                                )
                                    : orderData?.length > 0 ?
                                        (
                                            orderData.map((shipment, index) => (
                                                <tr className="border-t bg-white hover:bg-slate-50 transition-all">
                                                    <td className="px-4 py-3 text-gray-700 font-medium">{page * limit + index + 1}</td>
                                                    <td className="px-4 py-3 text-blue-600 font-semibold cursor-pointer">{shipment?.email}</td>
                                                    <td className="px-4 py-3 text-gray-700 font-bold">{shipment?.totalOrders}</td>
                                                    <td className="px-4 py-3 text-blue-600 font-semibold cursor-pointer hover:underline">
                                                        <Link to="/PendingPickupOrderList" state={{ customerId: shipment?.customerId, email: shipment?.email }}>
                                                            View Details
                                                        </Link>
                                                    </td>
                                                    <td className="py-2.5 text-sm px-4 border-b">
                                                        <button onClick={() => toggleClose(shipment?.customerId, !shipment?.isOpenTodayPickup)}
                                                            className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                                        >
                                                            {shipment?.isOpenTodayPickup ? "Close" : "Open"}
                                                        </button>
                                                    </td>

                                                </tr>

                                            )
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="16" className="text-center py-20">
                                                    <NoDataFound />
                                                </td>
                                            </tr>
                                        )}
                            </tbody>
                        </table>
                    </div>
                </div> */}
                {/* <CustomPagination
                    totalItems={GetOrderOrder?.getOpenTodayPickupOrder?.count || 0} // Total number of items
                    limit={limit}
                    pageNo={page} // Current page number (zero-based index)
                    handlePageClick={handlePageClick} // Handler to change page
                /> */}
            </div >
        </>
    )
}
export default OpenPendingPickupOrder
